import { css } from 'linaria';

export namespace styles {
  export const desktopContainer = css`
    display: flex;
    justify-content: space-between;
  `;
}

export const mediaMobile = 'only screen and (max-width: 767px)';
export const mediaMoreThenMobile = 'only screen and (min-width: 768px)';
export const mediaDesktop = 'only screen and (min-width: 1024px)';
